<template>
  <div style="display: block; width:100%">
    <Header />
    <Footer />
  </div>
</template>
<script>
import Header from "./components/elements/Header.vue";
import Footer from "./components/elements/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
